export function streamURL(station,{production=false}={}){
  const value=(station?.url_resolved||station?.url||'').trim();
  const url=new URL(value);
  if(!['http:','https:'].includes(url.protocol))throw new Error('Unsupported stream URL');
  if(production&&url.protocol==='http:'){url.protocol='https:';return url.href;}
  return value;
}
